import { COLORS } from '../components/Basics';
import { getTheme, resolveThemeId } from './lorentzThemes';

const CSS_VARS = [
  ['--lorentz-bg', 'app'],
  ['--lorentz-bg-elevated', 'backColor'],
  ['--lorentz-panel', 'app'],
  ['--lorentz-border', 'borderColor'],
  ['--lorentz-text', 'textPrimary'],
  ['--lorentz-muted', 'textSecondary'],
  ['--lorentz-accent', 'accent'],
  ['--lorentz-primary', 'primary'],
  ['--lorentz-danger', 'danger'],
  ['--lorentz-success', 'success'],
  ['--lorentz-warning', 'warning']
];

let mediaQuery = null;
let mediaHandler = null;
let currentPreference = 'auto';

function applyCssVariables(theme) {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  root.setAttribute('data-theme', theme.id);

  CSS_VARS.forEach(([cssVar, colorKey]) => {
    root.style.setProperty(cssVar, theme.colors[colorKey]);
  });

  const { themeColor, backgroundColor } = theme.meta;
  let themeMeta = document.querySelector('meta[name="theme-color"]');
  if (!themeMeta) {
    themeMeta = document.createElement('meta');
    themeMeta.name = 'theme-color';
    document.head.appendChild(themeMeta);
  }
  themeMeta.content = themeColor;

  document.body.style.backgroundColor = backgroundColor;
  document.body.style.color = theme.colors.textPrimary;
}

export function applyTheme(preference = 'auto') {
  currentPreference = preference;
  const resolvedId = resolveThemeId(preference);
  const theme = getTheme(preference);

  Object.assign(COLORS, theme.colors);
  applyCssVariables(theme);

  return { preference, resolvedId, theme };
}

export function initThemeWatcher(onChange) {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {};

  mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
  mediaHandler = () => {
    if (currentPreference !== 'auto') return;
    const result = applyTheme('auto');
    onChange?.(result);
  };

  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', mediaHandler);
  } else {
    mediaQuery.addListener(mediaHandler);
  }

  return () => {
    if (!mediaQuery || !mediaHandler) return;
    if (mediaQuery.removeEventListener) {
      mediaQuery.removeEventListener('change', mediaHandler);
    } else {
      mediaQuery.removeListener(mediaHandler);
    }
  };
}

export function getCurrentPreference() {
  return currentPreference;
}
